import React from 'react'
import { memberMobx } from '@mobxStore'
import './index.scss'

import memberImg from '@img/member/member.png'

interface IAvatarProps {
  onClick?: () => void;
}

const AvatarImg: React.FC<IAvatarProps> = (props: IAvatarProps) => {
  const { onClick } = props
  const { memberInfo } = memberMobx
  const { nickName, avatarUrl } = memberInfo
  const getClick = () => {
    onClick && onClick()
  }
  return (
    <>
      {
        avatarUrl ? (
          <div className='mkt-avatar' data-cypid='avatarImage' onClick={getClick}>
            <div className='mkt-avatar-img' style={{ backgroundImage: `Url(${avatarUrl})` }}></div>
          </div>
        ) : (
          <>
            {
              nickName ? (
                <div className='mkt-avatar mkt-avatar-character' data-cypid='avatarImage' onClick={getClick}>
                  <span className='mkt-avatar-character-text'>{nickName?.charAt(0)?.toUpperCase()}</span>
                </div>
              ) : (
                <div className='mkt-avatar' data-cypid='avatarImage' onClick={getClick}>
                  <div className='mkt-avatar-img' style={{ backgroundImage: `Url(${memberImg})` }}></div>
                </div>)
            }
          </>
        )
      }
    </>
  )
}

export default AvatarImg
